import { isEmpty, isNil } from 'lodash/fp';

import { CmsInsuranceTypeContent } from '../../../types';
import { CONTENT_SECTIONS } from '../../../content/sections';

const HARDCODED_TITLE = 'Choose cover that works for you';

type Props = {
  cmsSectionContent: CmsInsuranceTypeContent['productsByType'];
  hasTargetMarket: CmsInsuranceTypeContent['marketSegment'];
};

const mapProductContent = ({ cmsSectionContent, hasTargetMarket }: Props) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  const targetMarketContent = cmsSectionContent?.find(
    (content) => content.productType === hasTargetMarket?.identifier?.current,
  );

  return {
    content: isNil(targetMarketContent) ? cmsSectionContent : [targetMarketContent],
    title: HARDCODED_TITLE,
    type: CONTENT_SECTIONS.PRODUCTS,
  };
};

export default mapProductContent;
